/**
 * TypeWebhook
 * @author Simpli CLI generator
 */
import {$, Helper, Request, Resource} from 'simpli-web-sdk'
import {TypeWebhookCollection} from '@/model/collection/TypeWebhookCollection'

/* TODO: review generated class */
export class TypeWebhook extends Resource {
  idTypePk: number = 0

  nome: string | null = null
  ativo: boolean | null = null

  get $id() {
    return this.idTypePk
  }
  set $id(val) {
    this.idTypePk = val
  }
  get $tag() {
    return String(this.nome)
  }

  /**
   * Gets a instance of a given ID of TypeWebhook
   */
  async getTypeWebhook(id: number) {
    return await Request.get(`/admin/type-webhook/${id}`)
      .name('getTypeWebhook')
      .as(this)
      .getData()
  }

  /**
   * Deletes a instance of a given ID of TypeWebhook
   */
  async removeTypeWebhook() {
    return await Request.delete(`/admin/type-webhook/${this.$id}`)
      .name('removeTypeWebhook')
      .asNumber()
      .getData()
  }

  /**
   * Lists the instances of TypeWebhook
   */
  static async listTypeWebhook(params: any) {
    return await Request.get(`/admin/type-webhook`, {params})
      .name('listTypeWebhook')
      .as(TypeWebhookCollection)
      .getData()
  }

  /**
   * Persists a new instance of TypeWebhook. Use ID = 0 to create a new one,
   * or ID > 0 to update a current one
   */
  async persistTypeWebhook() {
    return await Request.post(`/admin/type-webhook`, this)
      .name('persistTypeWebhook')
      .asNumber()
      .getData()
  }

  /**
   * Lists the instances of TypeWebhook to use it in a CSV file
   */
  static async listCsvTypeWebhook(params: any) {
    return await Request.get(`/admin/type-webhook/csv`, {params})
      .name('listCsvTypeWebhook')
      .as(TypeWebhookCollection)
      .getData()
  }
}
